<template>
  <div>
    <NavBar />
    <h3>{{ t('settings-title') }}</h3>
    <UISettings class="settings">
      <component v-for="(section, i) in sections" :is="section" :key="i" />
    </UISettings>
    <!-- How the board looks with these settings. -->
    <div class="preview">
      <GameBoard :size="previewSize" :state="state" playMode="button" :autofocus="false"/>
    </div>
  </div>
</template>

<script>
import NavBar from './NavBar';
import UISettings from './UISettings';
import extensions from '@/extensions';
import GameBoard, { State, InputValidator } from './GameBoard';
import { SimpleStoneChain } from './GameBoard/StoneChain';
import Game from '@/game/Game';
import { t } from '@/texts';

// The opening of a 19×19 game, so that the preview looks like a real board: move numbers,
// coordinates, margins and the last-move marker at the size players see them.
const PREVIEW_MOVES = ['Q16', 'D4', 'Q3', 'D16', 'C14', 'F17', 'O17', 'R5', 'C6', 'F3', 'Q10',
  'K4', 'H16', 'P5', 'Q5', 'P4', 'R4', 'O3', 'C10', 'H17'];

class NoInput extends InputValidator {
  get inputType() { return null; }
  validate() { return false; }
}

export default {
  name: 'SettingsPage',
  components: { NavBar, UISettings, GameBoard },

  data() {
    const game = new Game();
    game.load({ id: 0, setup: { type: 'standard', grid: 19 }, status: 'in-progress',
      moves: [{ index: 0, move: '.set' }, ...PREVIEW_MOVES.map((m, i) => ({ index: i + 1, move: m, stone: i % 2 ? 'white' : 'black' }))] });
    return {
      sections: extensions.settingsSections,
      state: new State(game.grid, new SimpleStoneChain(game.moves), null, null, new NoInput()),
    };
  },

  computed: {
    // As wide as the phone, like the game page; 360 px on a computer.
    previewSize() {
      return this.$store.state.isMobile ? 0 : 360;
    },
  },



  methods: {
    t,

  },
}
</script>

<style scoped>
h3 {
  margin: 8px 0 4px;
}

.settings {
  max-width: 420px;
  margin: 0 auto;
  padding: 0 12px;
}

.preview {
  margin: 12px auto;
}
</style>
